import { reactive } from 'vue'
import { api } from '../api'
import { session } from './session'

// Numbers shown on the home screens and in the sidebar: question bank size (public catalog) and the signed-in
// learner's progress (/api/v1/learning/summary). Nothing is estimated: without a session the progress is zero.
export const learning = reactive({
  loaded: false,
  /** Questions per subject code (科一..科四) and in total, from the public catalog. */
  subjectCounts: {} as Record<string, number>,
  total: 0,
  mastered: 0,
  due: 0,
  today: 0,
  streak: 0,
  get stablePercent() { return this.total ? Math.min(100, Math.round(this.mastered / this.total * 100)) : 0 },
})

let inflight: Promise<void> | null = null

export function loadLearning(force = false): Promise<void> {
  if (inflight && !force) return inflight
  inflight = (async () => {
    const [catalog, summary] = await Promise.all([
      api.catalog().catch(() => null),
      session.signedIn ? api.summary().catch(() => null) : Promise.resolve(null),
    ])
    if (catalog) {
      const counts: Record<string, number> = {}
      for (const s of catalog.subjects) counts[s.subject] = s.chapters.reduce((n, c) => n + c.questionCount, 0)
      learning.subjectCounts = counts
      learning.total = Object.values(counts).reduce((n, v) => n + v, 0)
    }
    const chapters = summary?.subjects.flatMap(s => s.chapters) ?? []
    const sum = (key: 'mastered' | 'due') => chapters.reduce((n, c) => n + c[key], 0)
    learning.mastered = sum('mastered')
    learning.due = sum('due')
    learning.today = summary?.todayAttempts ?? 0
    learning.streak = summary?.streakDays ?? 0
    learning.loaded = true
  })()
  return inflight
}

/** Forget the cached numbers, e.g. after sign-in or sign-out. */
export function resetLearning() {
  inflight = null
  learning.mastered = 0
  learning.due = 0
  learning.today = 0
  learning.streak = 0
}
